<template>
  <Layout
    :assetType="assetType"
    :asset="asset"
    active="send"
    :title="`Sent | ${assetType.name}`"
  >
    <div class="flex-grow-1 flex-column d-flex py-5 bg-light flex-shrink-0">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2 text-center">
            <h3 class="mb-4">
              {{ assetType.name }} for {{ asset.counter_party.name }}
            </h3>
            <Icon
              icon="send"
              :width="140"
              colour="#e1e8fa"
              class="mb-5"
            />
            <span v-html="sentCopy" />
          </div>
        </div>
      </div>
    </div>

    <div class="container py-5">
      <div class="row">
        <div @click="handleClick" class="col-md-8 offset-md-2 text-center">
          <ArticleHeading
            :dynamic="false"
            :block="{value: 'What happens next?'}"
            :definitions="definitions"
          />
          <Paragraph
            :dynamic="false"
            :block="{value: `Once the ${assetType.long_name} is Approved, you can send it to the Counterparty for their review. Once agreed, you have a Contract!`}"
            :definitions="definitions"
          />
        </div>
      </div>
    </div>

    <Definition
      v-if="definition"
      @closeDefinitionPopup="closeDefinitionPopup"
      :definitionContent="definitionContent"
      :definitionPosition="definitionPosition"
    />

    <Schedule
      v-if="schedule"
      @closeSchedulePopup="() => schedule = false"
      :scheduleContent="scheduleContent"
    />
  </Layout>
</template>

<script>
import Layout from './Layout';
import Options from '@/Shared/Options';
import Icon from '@/Icons/Icon';
import Paragraph from '@/Pages/Asset/Contract/Components/Paragraph';
import ArticleHeading from '@/Pages/Asset/Contract/Components/ArticleHeading';
import popupMixin from '@/Mixins/popupMixin';

export default {
  mixins: [popupMixin],

  components: {
    Layout,
    Options,
    Icon,
    Paragraph,
    ArticleHeading,
  },

  props: {
    assetType: Object,
    asset: Object,
    source: String,
  },

  mounted() {
    // hide any models that are open from the signed contract screen
    // eslint-disable-next-line no-undef
    $('.modal-backdrop').remove();
  },

  computed: {
    sentCopy() {
      let copy = '';

      if (this.source === 'internal') {
        copy = '<p>Your document has been sent to your Approver for review.</p><p>You will receive a notification when they have completed reviewing and/or editing the document.</p>';
      }

      if (this.source === 'external') {
        copy = '<p>Your document has a been sent to the Counterparty.</p><p>They will receive an email letting them know that the document is with them to review and/or edit.</p><p>You will receive a notification when they have completed reviewing and/or editing the document.</p>';
      }

      if (this.source === 'originator') {
        copy = '<p>Your document has a been sent back to the Originating Party.</p><p>They will receive a notification that the document is now back with them to action.</p>';
      }

      if (this.source === 'approved') {
        copy = '<p>Your document has a been sent back to the Contract Lead.</p><p>They will receive a notification that the document is now back with them.</p>';
      }

      return copy;
    },
  },
};
</script>
